import { captureConsoleIntegration, init } from "@sentry/react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router";
import { config } from "./config";
import { Routes } from "./routes";

import "react";

declare module "react" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface HTMLAttributes<T> {
    [dataAttribute: `data-${string}`]: string;
  }
}

init({
  ...config.sentry,
  integrations: [captureConsoleIntegration({ levels: ["error", "assert"] })],
});

const router = createBrowserRouter(createRoutesFromElements(Routes));

const root = createRoot(document.getElementById("root")!);
root.render(<RouterProvider router={router} />);
